module.exports = __webpack_public_path__ + "img/monitoring-bus-red.aec937fa.svg";